import { Component, OnInit, Input} from '@angular/core';
import {EnvUtils, PubSubService, RouterUtils, StorageUtils} from '../../shared/utils';
import {MsgPopupService} from '../../shared/services/src/msg-popup.service';
import {NavigationStart, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {EnvLoadService} from '../../env-load/env-load.service';
import {KeycloakloginService} from '../../shared';
import {IntegratedKeycloakloginService} from '../../shared';

@Component({
    selector: 'msg-popup',
    templateUrl: './msg-popup.component.html'
})

export class MsgPopupComponent implements OnInit {
    header_msg = '';
    contents_msg = '';
    btn_msg = 'MK.00049'; // OK

    cancel_btn = '';
    close_btn_use_flag = false;
    redirect_flag = true;
    redirect_url = '';
    navigationId = 0;

    andebug = false;
    isOpsnow = false;

    constructor(private _pubsub: PubSubService,
                private _msgPopupService: MsgPopupService,
                public router: Router,
                public httpClient: HttpClient,
                private keycloakloginService: KeycloakloginService,
                private integratedKeycloakloginService: IntegratedKeycloakloginService,
                public envLoadService: EnvLoadService) {
        this.andebug = StorageUtils.getItem('an.debug') === 'd' ? true : false;

        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart ) {
                $.magnificPopup.close();
                this.navigationId = event.id;
            }
        });

        // API 호출 시 글로벌 에러 메시지 팝업
        this._pubsub.afterRequest.subscribe(data => {
            if (data['status'] === 'error') {
                this.httpErrorMsg(data['body']);
            }
            // keycloak token 만료시
            if (data['status'] === 'token_expiration') {
                $.magnificPopup.open({
                    items: {
                        src: '#tokenInvalidPopup',
                    },
                });
                setTimeout(() => {
                    this.integratedKeycloakloginService.logout({'redirectUri' : global['logOutUrl']});
                }, 3000);
            }
        });

        // resource guard, objectLink, split view 접근 권한 확인
        this._msgPopupService.msgEvent.subscribe(data => {
            if (this.andebug) console.log(data);

            this.header_msg = data.header_msg;
            this.contents_msg = data.contents_msg;
            this.cancel_btn = data.cancel_btn === undefined ? '' : data.cancel_btn;
            this.close_btn_use_flag = data.close_btn_use_flag;
            this.redirect_flag = data.redirect_flag === undefined ? false : data.redirect_flag;
            this.redirect_url = data.redirect_url === undefined ? '' : data.redirect_url;
            //this.redirect_url = data.redirect_url === '' ? true : false;
            $.magnificPopup.open({
                items: {
                    src: '#msg-popup-component',
                },
            });
        });
    }

    ngOnInit() {

    }

    httpErrorMsg(error) {
        console.log('An error occurred [msg-popup]');
        console.log(error);
        console.log(error.status);

        let errorBody;
        try {
            errorBody = JSON.parse(error._body);
        } catch (e) {
            console.log('return');
            return;
        }

        const responder = errorBody.responder;
        const redirectUrlCd = errorBody.redirectUrlCd;

        let messageKey = errorBody.messageKey;
        let titlekey;
        const cancelBtn = '';
        const closeBtnUseFlag = false;

        let url = '';

        const redirect_url = window.location.origin;

        let tokenKey: string;
        if (process.env.ENV === 'production') {
            tokenKey = 'access_token';
        } else {
            tokenKey = 'access_token_dev';
        }
        const token = $.cookie(tokenKey);

        if (error.status === 401) {
            if (this.andebug) console.log('[msg-popup] 401: ', responder);

            if (responder === undefined || responder === '') {
                if (this.andebug) console.log('[msg-popup] 401 if');

                // titlekey = 'MK.00791';                          //세션만료
                // messageKey = 'MK.00789';                        //연결 기간이 만료되었습니다. <br /> 로그인 페이지로 이동합니다.
            } else {
                if (this.andebug) console.log('[msg-popup] 401 else');

                if (redirectUrlCd === 'portal') {
                    titlekey = 'MK.00792';                      //권한없음
                    messageKey = 'MK.00790';                    //서비스 가입 정보가 존재하지 않습니다.<br />신규 서비스 신청 시에는 서비스 구성을 위해 5분 정도 시간이 소요됩니다. 잠시 후 다시 접속 해 주세요.
                    url = global['urlInfo'].opsnow360Url;          //포탈페이지로 이동
                }
            }
        } else if (error.status === 403) {                      //접근 거부
            if (this.andebug) console.log('[msg-popup] 403: ', responder, messageKey);

            if (responder === undefined || responder === '' || messageKey === 'MK.00972' || messageKey === 'MK.01904') { //responder가 없는 경우 => 포탈에서 발생 시킨 경우로 로그아웃 페이지로 이동 시켜야함
                if (this.andebug) console.log('[msg-popup] 403 if');

                // titlekey = 'MK.01903';                          //중복된 계정 접속
                // messageKey = 'MK.01904';                        //다른 기기에서 동일한 계정으로 로그인이 시도되었습니다.<br> 로그아웃하고 현재 기기에서 다시 로그인 하시겠습니까?
                // cancelBtn = 'MK.00048';
                // closeBtnUseFlag = true;
            } else {
                if (this.andebug) console.log('[msg-popup] 403 else');

                titlekey = 'MK.00792';                          //권한 없음
                messageKey = 'MK.00947';                        //접근이 거부 되었습니다
            }
        } else {
            if (this.andebug) console.log('[msg-popup] else');

            if (messageKey === 'MK.00963') {                    //서비스 가입 정보가 존재하지 않습니다.
                titlekey = 'MK.00792';                          //권한 없음
                url = global['urlInfo'].opsnow360Url;
            }
        }

        //리다이렉트처리 리다이렉트코드가 있는경우
        if (redirectUrlCd === 'portal') {
            url = global['urlInfo'].opsnow360Url;
        }

        let redirectTime = 100;
        //팝업처리 : 메세지 키가 있는경우
        if (messageKey !== undefined && messageKey !== '') {
            redirectTime = 3000;

            if (titlekey === null || titlekey === undefined || titlekey === '') {
                titlekey = 'MK.00894';  // 알림
            }

            this.header_msg = titlekey;
            this.contents_msg = messageKey;
            this.cancel_btn = cancelBtn === undefined ? '' : cancelBtn;
            this.close_btn_use_flag = closeBtnUseFlag;

            $.magnificPopup.open({
                items: {
                    src: '#msg-popup-component',
                },
            });
        }

        if ((redirectUrlCd !== undefined && redirectUrlCd !== '') || url !== '') {
            console.log('redirectTime', redirectTime);
            setTimeout(() => {
                location.href = url;
            }, redirectTime);
        }

        //스피너 제거
        setTimeout(() => {
            $('.spinner').removeClass('spinner');
        }, 100);

    }

    // 중복된 계정 접속 팝업 취소
    cancel() {
        const tokenKey = EnvUtils.envCdToTokenKey();
        $.cookie(tokenKey, null, {domain: global['sub_domain'], expires: -1});
        const refreshKey = EnvUtils.envCdToRefreshKey();
        $.cookie(refreshKey, null, {domain: global['sub_domain'], expires: -1});
        // keycloak 로그아웃
        this.keycloakloginService.logout({'redirectUri' : this.envLoadService.brandUrl});
    }

    // 중복된 계정 접속 팝업 확인
    close() {
        $.magnificPopup.close();
        // 로그아웃 처리 (현재 세션 제외)
        this.keycloakloginService.logoutAllSession(true);
    }

    popupClose(redirect?) {
        $.magnificPopup.close();
        if (!!redirect) {
            if (this.navigationId === 1) {
                console.log('loading !');
                this.router.navigate(['/']);
            } else if (this.redirect_url !== '') {
                console.log('loading !!');
                // this.router.navigate([this.redirect_url]);
                const params = {
                    viewType : 'list'
                };
                RouterUtils.navigate(this.router, '/incident/incident/', params);
            }
        }
    }

    tokenInvalidPopupClose() {
        $.magnificPopup.close();

        const tokenKey = EnvUtils.envCdToTokenKey();
        $.cookie(tokenKey, null, {domain: global['sub_domain'], expires: -1});
        const refreshKey = EnvUtils.envCdToRefreshKey();
        $.cookie(refreshKey, null, {domain: global['sub_domain'], expires: -1});
        this.integratedKeycloakloginService.logout({'redirectUri' : global['logOutUrl']});
    }

}



// WEBPACK FOOTER //
// ./src/app/components/msg-popup/msg-popup.component.ts